import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/login',
    },
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '/about',
          name: 'about',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
        },
        {
          path: '/casal/cadastro',
          name: 'cadastro_casal',
          component: () => import('./views/casal/Cadastro.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/casal/editar/:id',
          name: 'editar_casal',
          component: () => import('./views/casal/Cadastro.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/casal/lista',
          name: 'lista_casal',
          component: () => import('./views/casal/Lista.vue'),
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
  ],
});

export default router;
